export const QBR_TRANSLATIONS_NAMESPACE = 'jbp-qbr-documents'

export const TRANSLATION_KEYS = {
  partnerTypeButtonPrefix: QBR_TRANSLATIONS_NAMESPACE,
  next: `${QBR_TRANSLATIONS_NAMESPACE}--next`,
  cancel: `${QBR_TRANSLATIONS_NAMESPACE}--cancel`,
  save: `${QBR_TRANSLATIONS_NAMESPACE}--save`,
  saveAs: `${QBR_TRANSLATIONS_NAMESPACE}--save-as`,
  refreshDocument: `${QBR_TRANSLATIONS_NAMESPACE}--refresh-document`,
  refreshDocumentToFetchCompetitors: `${QBR_TRANSLATIONS_NAMESPACE}--refresh-document-to-fetch-competitors`,
  finalizeDocument: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-document`,
  finalizeDocumentError: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-document-error`,
  finalizeAlert: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-alert`,
  return: `${QBR_TRANSLATIONS_NAMESPACE}--return`,
  error: `${QBR_TRANSLATIONS_NAMESPACE}--error`,
  partnersFetchingError: `${QBR_TRANSLATIONS_NAMESPACE}-partners-fetching-error`,
  downloadAllAttachments: {
    title: `${QBR_TRANSLATIONS_NAMESPACE}--download-all-attachments--title`,
    noData: `${QBR_TRANSLATIONS_NAMESPACE}--download-all-attachments--no-data`,
  },
  finalizeModal: {
    title: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-modal--title`,
    text: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-modal--text`,
    finalizeWithSaving: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-modal--finalize-with-saving`,
    finalizeWithoutSaving: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-modal--finalize-without-saving`,
    cancel: `${QBR_TRANSLATIONS_NAMESPACE}--finalize-modal--cancel`,
  },

  dnaLoadDate: `${QBR_TRANSLATIONS_NAMESPACE}--dna-load-date`,
  emptyOfferings: `${QBR_TRANSLATIONS_NAMESPACE}--empty-offerings`,

  reportIssue: `${QBR_TRANSLATIONS_NAMESPACE}--repport-issue`,
  reportIssueModal: {
    title: `${QBR_TRANSLATIONS_NAMESPACE}--report-issue-modal--title`,
    text: `${QBR_TRANSLATIONS_NAMESPACE}--report-issue-modal--text`,
    subject: `${QBR_TRANSLATIONS_NAMESPACE}--report-issue-modal--subject`,
    body: `${QBR_TRANSLATIONS_NAMESPACE}--report-issue-modal--body`,
    save: `${QBR_TRANSLATIONS_NAMESPACE}--report-issue-modal--save`,
    cancel: `${QBR_TRANSLATIONS_NAMESPACE}--report-issue-modal--cancel`,

    deleteAttachment: `${QBR_TRANSLATIONS_NAMESPACE}--report-issue-modal--delete-attachment`,
  },

  unpopulatedDataBlock: {
    title: `${QBR_TRANSLATIONS_NAMESPACE}--unpopulated-data--title`,
    pleaseCheck: `${QBR_TRANSLATIONS_NAMESPACE}--unpopulated-data--please-check`,
    nameInputEmpty: `${QBR_TRANSLATIONS_NAMESPACE}--unpopulated-data--name-input-empty`,
    offeringsEmpty: `${QBR_TRANSLATIONS_NAMESPACE}--unpopulated-data--offerings-empty`,
    partnersEmpty: `${QBR_TRANSLATIONS_NAMESPACE}--unpopulated-data--partners-empty`,
  },

  unsavedChangesBlock: {
    title: `${QBR_TRANSLATIONS_NAMESPACE}--unsaved-changes--title`,
    subTitle: `${QBR_TRANSLATIONS_NAMESPACE}--unsaved-changes--subtitle`,
  },

  saveConfirmDialog: {
    saveSettingModalConfirm: `${QBR_TRANSLATIONS_NAMESPACE}--save-settings-modal-confirm`,
    saveSettingModalButton: `${QBR_TRANSLATIONS_NAMESPACE}--save-settings-modal`,
    saveAsModalConfirm: `${QBR_TRANSLATIONS_NAMESPACE}--save-as-modal-confirm`,
    saveAsModalButton: `${QBR_TRANSLATIONS_NAMESPACE}--save-as-modal`,
  },

  qbrCloneDialog: {
    cloneRecordTitle: `${QBR_TRANSLATIONS_NAMESPACE}--clone-record`,
    inputPlaceholder: `${QBR_TRANSLATIONS_NAMESPACE}--qbr-clone-dialog--input-placeholder`,
    saveButton: `${QBR_TRANSLATIONS_NAMESPACE}--save-button`,
  },

  buttons: {
    createRecordButton: `${QBR_TRANSLATIONS_NAMESPACE}--create-record`,
    deleteRecordButton: `${QBR_TRANSLATIONS_NAMESPACE}--delete-record`,
    deletePartnerFromDocument: `${QBR_TRANSLATIONS_NAMESPACE}--delete-partner-from-document`,
    deleteRecordButtonConfirm: `${QBR_TRANSLATIONS_NAMESPACE}--delete-record-confirm`,
    uploadDocument: `${QBR_TRANSLATIONS_NAMESPACE}--upload-document`,
    openPartnerPlanTooltip: `${QBR_TRANSLATIONS_NAMESPACE}--partner-plan-tooltip`,
    deletePartnerTooltip: `${QBR_TRANSLATIONS_NAMESPACE}--delete-partner-tooltip`,
    errorModalConfirm: `${QBR_TRANSLATIONS_NAMESPACE}--error-modal-confirm`,
    closeButton: `${QBR_TRANSLATIONS_NAMESPACE}--close-button`,
    errorModalCheckbox: `${QBR_TRANSLATIONS_NAMESPACE}--error-modal-checkbox`,
    errorOccured: `${QBR_TRANSLATIONS_NAMESPACE}--error-occured`,
    notSaved: `${QBR_TRANSLATIONS_NAMESPACE}--not saved`,
    errorModalMainText: `${QBR_TRANSLATIONS_NAMESPACE}--error-modal-main-text`,
  },

  tableFilters: {
    onlyLegacy: `${QBR_TRANSLATIONS_NAMESPACE}--table-filters-only-legacy`,
    applyFilters: `${QBR_TRANSLATIONS_NAMESPACE}--table-filters-apply`,
    clearFilters: `${QBR_TRANSLATIONS_NAMESPACE}--table-filters-clear`,
  },
  tableColumns: {
    versionName: `${QBR_TRANSLATIONS_NAMESPACE}--version-name`,
    numberOfPartners: `${QBR_TRANSLATIONS_NAMESPACE}--num-of-partners`,
    fyear: `${QBR_TRANSLATIONS_NAMESPACE}--fyear`,
    region: `${QBR_TRANSLATIONS_NAMESPACE}--region`,
    market: `${QBR_TRANSLATIONS_NAMESPACE}--market`,
    netNdp: `${QBR_TRANSLATIONS_NAMESPACE}--net-ndp`,
    currency: `${QBR_TRANSLATIONS_NAMESPACE}--currency`,
    offerings: `${QBR_TRANSLATIONS_NAMESPACE}--offerings`,
    creator: `${QBR_TRANSLATIONS_NAMESPACE}--creator`,
    status: `${QBR_TRANSLATIONS_NAMESPACE}--status`,
    isLegacyDocument: `${QBR_TRANSLATIONS_NAMESPACE}--is-legacy-document`,
    attachments: `${QBR_TRANSLATIONS_NAMESPACE}--attachment`,
    cloneColumn: `${QBR_TRANSLATIONS_NAMESPACE}--clone-column`,
    deleteColumns: `${QBR_TRANSLATIONS_NAMESPACE}--delete`,
  },

  navigation: {
    settings: `${QBR_TRANSLATIONS_NAMESPACE}--settings`,
    documentAtGlance: `${QBR_TRANSLATIONS_NAMESPACE}--document-at-glance`,
    planAchievement: `${QBR_TRANSLATIONS_NAMESPACE}--plan-achievement`,
    sobAchievement: `${QBR_TRANSLATIONS_NAMESPACE}--sob-achievement`,
    initiatives: `${QBR_TRANSLATIONS_NAMESPACE}--initiatives`,
    sobCompetitors: `${QBR_TRANSLATIONS_NAMESPACE}--sob-competitors`,
    export: `${QBR_TRANSLATIONS_NAMESPACE}--export`,
    attachments: `${QBR_TRANSLATIONS_NAMESPACE}--attachments`,
  },

  settings: {
    period: `${QBR_TRANSLATIONS_NAMESPACE}--settings-period`,
    periodCurrentFQuarterWarning: `${QBR_TRANSLATIONS_NAMESPACE}--settings-period--current-fquarter-warning-message`,
    offerings: `${QBR_TRANSLATIONS_NAMESPACE}--settings-offerings`,
    fYearAndQuarterTitle: `${QBR_TRANSLATIONS_NAMESPACE}--settings-fyear-and-quarter-title`,
    titleOfferingsSettings: `${QBR_TRANSLATIONS_NAMESPACE}--settings-title-offerings-settings`,
    titleSwitcherSettings: `${QBR_TRANSLATIONS_NAMESPACE}--settings-title-switcher-settings`,
    currencyAndValueType: `${QBR_TRANSLATIONS_NAMESPACE}--settings-currency`,
    name: `${QBR_TRANSLATIONS_NAMESPACE}--settings-name`,
    isLegacyDocument: `${QBR_TRANSLATIONS_NAMESPACE}--settings-is-legacy-document`,
    rounding: `${QBR_TRANSLATIONS_NAMESPACE}--settings-rounding`,
    addDistributors: `${QBR_TRANSLATIONS_NAMESPACE}--settings-add-distributors`,
    addCommercials: `${QBR_TRANSLATIONS_NAMESPACE}--settings-add-commercials`,
    keyOptionText: `${QBR_TRANSLATIONS_NAMESPACE}--settings-key-option-text`,
    offeringsWarning: `${QBR_TRANSLATIONS_NAMESPACE}--settings-offerings-warning`,
    isGlobalPlans: `${QBR_TRANSLATIONS_NAMESPACE}--settings-is-global-plans`,
    headerMain: `${QBR_TRANSLATIONS_NAMESPACE}--settings-header-main`,
    headerSecond: `${QBR_TRANSLATIONS_NAMESPACE}--settings-header-second`,
    qbrHighlightPositiveHeaderFirst: `${QBR_TRANSLATIONS_NAMESPACE}--positive-header-first`,
    qbrHighlightPositiveHeaderSecond: `${QBR_TRANSLATIONS_NAMESPACE}--positive-header-second`,
    qbrHighlightNegativeHeaderFirst: `${QBR_TRANSLATIONS_NAMESPACE}--negative-header-first`,
    qbrHighlightNegativeHeaderSecond: `${QBR_TRANSLATIONS_NAMESPACE}--negative-header-second`,
  },
  addPartnersModal: {
    titleDistributors: `${QBR_TRANSLATIONS_NAMESPACE}--title-distributors`,
    titleCommercials: `${QBR_TRANSLATIONS_NAMESPACE}--title-commercials`,
    warning: `${QBR_TRANSLATIONS_NAMESPACE}--add-partner-modal-warning`,
    legacyDocumentWarning: `${QBR_TRANSLATIONS_NAMESPACE}--add-partner-modal-legacy-document-warning`,
    partnersCountDistributors: `${QBR_TRANSLATIONS_NAMESPACE}--partners-count-distributors`,
    partnersCountCommercials: `${QBR_TRANSLATIONS_NAMESPACE}--partners-count-commercials`,
    save: `${QBR_TRANSLATIONS_NAMESPACE}--add- partners-modal-save`,
    filter: {
      myPartnersCheckbox: `${QBR_TRANSLATIONS_NAMESPACE}--my-partners-checkbox`,
      geo: `${QBR_TRANSLATIONS_NAMESPACE}--geo`,
      pids: `${QBR_TRANSLATIONS_NAMESPACE}--pids`,
      applyFilter: `${QBR_TRANSLATIONS_NAMESPACE}--apply-filter`,
      clearFilter: `${QBR_TRANSLATIONS_NAMESPACE}--clear-filter`,
    },
    table: {
      communicationName: `${QBR_TRANSLATIONS_NAMESPACE}--communication-name`,
      country: `${QBR_TRANSLATIONS_NAMESPACE}--country`,
      geoMarket: `${QBR_TRANSLATIONS_NAMESPACE}--geo-market`,
      geoRegion: `${QBR_TRANSLATIONS_NAMESPACE}--geo-region`,
      hierarchyType: `${QBR_TRANSLATIONS_NAMESPACE}--hierarchy-type`,
      locationId: `${QBR_TRANSLATIONS_NAMESPACE}--location-id`,
      partnerId: `${QBR_TRANSLATIONS_NAMESPACE}--partner-id`,
      plan: `${QBR_TRANSLATIONS_NAMESPACE}--plan`,
      pbm: `${QBR_TRANSLATIONS_NAMESPACE}--pbm`,
      manager: `${QBR_TRANSLATIONS_NAMESPACE}--manager`,
    },
  },
  financialTable: {
    actual: `${QBR_TRANSLATIONS_NAMESPACE}--fin-table-actual`,
    plan: `${QBR_TRANSLATIONS_NAMESPACE}---fin-table-plan`,
    actToPlan: `${QBR_TRANSLATIONS_NAMESPACE}--fin-table-act-to-plan`,
    yoy: `${QBR_TRANSLATIONS_NAMESPACE}--fin-table-yoy`,
    yoyActual: `${QBR_TRANSLATIONS_NAMESPACE}--fin-table-yoy-actual`,
    yoyPlan: `${QBR_TRANSLATIONS_NAMESPACE}---fin-table-yoy-plan`,
    yoySob: `${QBR_TRANSLATIONS_NAMESPACE}--fin-table-yoy-sob`,
    chartLabelSob: `${QBR_TRANSLATIONS_NAMESPACE}--chart-label-sob`,

    selectedPeriodWithFQuarters: `${QBR_TRANSLATIONS_NAMESPACE}--selected-periods-with-percent`,
    columns: {
      Q1: `${QBR_TRANSLATIONS_NAMESPACE}--plan-achievement--q1-column-title`,
      Q2: `${QBR_TRANSLATIONS_NAMESPACE}--plan-achievement--q2-column-title`,
      Q3: `${QBR_TRANSLATIONS_NAMESPACE}--plan-achievement--q3-column-title`,
      Q4: `${QBR_TRANSLATIONS_NAMESPACE}--plan-achievement--q4-column-title`,
      total: `${QBR_TRANSLATIONS_NAMESPACE}--plan-achievement--total-column-title`,
      totalUpToDate: `${QBR_TRANSLATIONS_NAMESPACE}--plan-achievement--total-up-to-date-column-title`,
    },
  },

  charts: {
    firstChildrenLevel: `${QBR_TRANSLATIONS_NAMESPACE}--charts-first-children-level`,
    secondChildrenLevel: `${QBR_TRANSLATIONS_NAMESPACE}--charts-second-children-level`,
  },
}
